import { useParams, useHistory } from "react-router-dom";
import { Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@common-ui/ui";

import { getOrg } from "../../services";

//Components
import { Header, ProfileBreadcrumbs } from "../../components";
import { MyOrgProfile } from "./MyOrgProfile";
import { NoOrg } from "./NoOrg";

export const ViewMyOrg = () => {
  let params = useParams();
  let history = useHistory();
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  const OrgId = params?.orgId || currentOrganization?.id;

  const [isLoading, setIsLoading] = useState(true);
  const [currentOrgData, setCurrentOrgData] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OrgId]);

  async function init() {
    try {
      if (OrgId) {
        let data = await getOrg(OrgId);
        setCurrentOrgData(data);
        console.log("data", data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  return (
    <Page title="FlukeWorks">
      <Header xl name="View Organization" history={history} />
      {!isLoading &&
      (currentOrgData?.id === "undefined" || !currentOrgData?.id) ? (
        <NoOrg />
      ) : (
        <>
          <ProfileBreadcrumbs>
            <Typography>{currentOrgData?.name}</Typography>
          </ProfileBreadcrumbs>
          <MyOrgProfile id={OrgId} data={currentOrgData} />
        </>
      )}
    </Page>
  );
};
